


































































import {
  defineComponent, ref, computed, watch, PropType,
} from '@vue/composition-api';
import moment from 'moment';
import filesize from 'filesize';

type Dandiset = {};
interface DandisetStats {
  bytes: number;
  folders: number;
  items: number;
}

export default defineComponent({
  name: 'DandisetList',
  props: {
    dandisets: {
      type: Array as PropType<Dandiset[]>,
      required: true,
    },
  },
  setup(props, ctx) {
    // Will be replaced by `useRoute` if vue-router is upgraded to vue-router@next
    // https://next.router.vuejs.org/api/#useroute
    const route = ctx.root.$route;

    const origin = computed(() => {
      const { name, params, query } = route;
      return { name, params, query };
    });

    const items = computed(() => props.dandisets);
    const dandisetStats = ref<DandisetStats[] | null>(null);
    async function fetchDandisetStats(dandisets: Dandiset[]) {
      // Set back to null in case of failure
      dandisetStats.value = null;

      dandisetStats.value = dandisets as DandisetStats[];
    }

    // Fetching dandiset stats must be done this way since we don't have access to asyncComputed
    watch(() => props.dandisets, fetchDandisetStats, { immediate: true });

    function formatDate(date: string) {
      return moment(date).format('LL');
    }

    return {
      origin,
      items,
      dandisetStats,
      formatDate,

      // Returned imports
      filesize,
    };
  },
});
